import React from 'react';
import { RootStoreContext } from '../stores/RootStore';
export const injectStores = (WrappedComponent) => {
    const ExtendedComponent = class extends WrappedComponent {
        constructor(props) {
            super(props);
            Object.getOwnPropertyNames(this.props.rootStore).forEach((propertyName) => {
                if (this[propertyName] === undefined) {
                    Object.defineProperty(this, propertyName, { ...Object.getOwnPropertyDescriptor(this, propertyName), value: this.props.rootStore[propertyName] });
                }
            });
        }
    };
    return (props) => {
        const rootStore = React.useContext(RootStoreContext);
        return (React.createElement(ExtendedComponent, { ...props, rootStore: rootStore }, props.children));
    };
};
